// action
import {
    GET_UPCOMING_CONSULTATION,
    GET_UPCOMING_CONSULTATION_FAIL,
    GET_UPCOMING_CONSULTATION_SUCCESS,
    GET_UPCOMING_CONSULTATION_RESET
} from '../action/getUpcominConsultationAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case GET_UPCOMING_CONSULTATION:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_UPCOMING_CONSULTATION_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_UPCOMING_CONSULTATION_SUCCESS: 
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
            }
        case GET_UPCOMING_CONSULTATION_RESET:
            return initialState
        default:
            return {
                ...state
            }
    }
}